import Delay from '@/webgl/core/Delay'
import Signal from '@/webgl/core/Signal'
import GameWorld from '@/webgl/runner/GameWorld'
import { IRunnerRenderer } from '@/webgl/runner/interfaces/IRunnerRenderer'
import { ScenarioSetup } from '@/webgl/runner/scenarios/ScenarioSetup.types'
import ScrollSystem from '@/webgl/runner/systems/ScrollSystem'
import { IGameSegment } from '@/webgl/runner/systems/SequencingSystem'

type TransitionOptions = {
  autoReopen: boolean
  close: boolean
}

export class TransitionSegment implements IGameSegment {
  onComplete = new Signal<void>()

  scroll: ScrollSystem
  world: GameWorld
  renderer: IRunnerRenderer

  constructor(
    readonly id: string,
    readonly options: Partial<TransitionOptions> = {}
  ) {}

  init(world: GameWorld, renderer: IRunnerRenderer, setup: ScenarioSetup) {
    this.world = world
    this.renderer = renderer
    this.scroll = this.world.systems.get<ScrollSystem>(ScrollSystem)
  }

  start(): void {
    this.scroll.stop(1.5).then(() => this.onComplete.emit())

    if (this.options.close) this.renderer.eye.close()

    Delay(1500).then(() => {
      // if (this.options.autoReopen)
      // this.renderer.eye.open();
      this.onComplete.emit(null)
    })
  }

  stop() {}
}
